<div class="row form" *ngIf="book != null">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 p-l-0 p-r-0">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-4">
          <h4 class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>Detalle Cuadre agencia</h4>
        </div>
        <div class="col-sm-8 form__head__boxBtn">
          <button class="btn btn-sm btn-danger" *ngIf="book.is_debt == false" (click)="delete(book)"><i
              class="fas fa-trash-alt m-r-2"></i>Borrar</button>
          <button type="button" class="btn btn-success m-r-5" *ngIf="book.is_debt == false" (click)="isDebt()">
            <i class="fas fa-check m-r-5"></i> LIQUIDAR
          </button>
          <button type="button" class="btn btn-light btn-sm m-r-5" (click)="printer()">
            <i class="fas fa-print m-r-5"></i> Imprimir
          </button>
          <div class="btn-group btn-group-sm">
            <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false">
              Exportar
            </button>
            <div class="dropdown-menu">
              <a target="_blank" href="/{{branchofficeSlug}}/api/blocksagency/detail/export/{{format_excel}}/{{book.id}}" class="dropdown-item" href="#"><i class="far fa-file-excel text-success m-r-5"></i>Formato Excel</a>
              <!-- <a class="dropdown-item" href="#">Exportar Pdf</a> -->
            </div>
          </div>
        </div>
      </div> <!-- end row -->
    </div>
  </div>

  <div class="col-lg-12 p-l-0 p-r-0" id="body">
    <div class="card m-b-20">
      <div class="card-body p-l-5 p-r-5 p-t-5 p-b-0 faq-box boder-left-dark">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__background">
            <div id="test" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail position-relative">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Código</div>
                <div class="child-right">
                  <span class="bold color-link">{{book.code}}</span>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Fecha generada</div>
                <div class="child-right">
                  {{book.created_at | date: 'mediumDate'}}
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Agencia Viaje</div>
                <div class="child-right bold">
                  {{book.agency_data.tradename}}
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Observaciones</div>
                <div class="child-right">
                  <span>{{book.observation}}</span>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Balance Traspaso</div>
                <div class="child-right">
                  <span class="text-danger bold">{{toolsService.momeySol()}}{{book.balance_transfers}}</span>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Balance Recibido</div>
                <div class="child-right">
                  <span class="text-success bold">{{toolsService.momeySol()}}{{book.balance_receiveds}}</span>
                </div>
              </div>
              <!-- <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Diferencia</div>
                <div class="child-right">
                  <ng-container *ngIf="book.balance_transfers > book.balance_receiveds">
                    <span class="badge badge-danger f-s-10">Diferencia negativa, pagar</span>
                    <span class="m-l-5">-{{toolsService.momeySol()}}{{book.balance_transfers - book.balance_receiveds}}</span>
                  </ng-container>
                  <ng-container *ngIf="book.balance_transfers < book.balance_receiveds">
                    <span class="badge badge-success f-s-10">Diferencia positiva, cobrar</span>
                    <span class="m-l-5">{{toolsService.momeySol()}}{{book.balance_transfers - book.balance_receiveds}}</span>
                  </ng-container>
                </div>
              </div> -->
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Estado</div>
                <div class="child-right">
                  <span *ngIf="!book.is_debt" class="badge badge-warning">No liquidado</span>
                  <span *ngIf="book.is_debt" class="badge badge-success">Liquidado</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <p class="form__group__title text-danger bold"><i class="fas fa-arrow-right text-danger m-r-5"></i> TRASPASOS
        </p>
        <div class="table-responsive">
          <table class="table mb-0 table-sm">
            <thead class="thead-default">
              <tr>
                <th>Responsable y Código</th>
                <th class="nowrap">Hotel / Ubicacion</th>
                <th>Tour</th>
                <th class="text-center">N° PAX</th>
                <th class="text-center">Fecha</th>
                <th class="text-center">P. Corporativo</th>
                <th class="text-center">C. Delegada</th>
                <th class="text-center">Obs.</th>
                <th class="text-center">Total</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="transfers.length == 0">
                <tr>
                  <td colspan="7">
                    No se encontraron registros.
                  </td>
                </tr>
              </ng-container>
              <ng-container *ngIf="transfers.length > 0">
                <tr *ngFor="let item of transfers; let index_ = index">
                  <td>
                    {{item.client_fullname}} <span class="m-l-2 f-s-10">({{item.client_cellphone}})</span>
                    <p class="m-b-2 f-s-11 bold" style="color: #a56b6b;">
                      {{item.booking_code}}<span class="badge badge-info f-s-9 m-l-3"
                        *ngIf="item.is_received">Recibido</span>
                    </p>
                  </td>
                  <td>{{item.reference_location}}</td>
                  <td>{{item.tour}}</td>
                  <td class="text-center">
                    {{item.quantity}}
                  </td>
                  <td class="text-center">
                    {{item.date_assigned}}
                  </td>
                  <td class="text-center">
                    {{item.price_corporate | currency:'S/. '}}
                  </td>
                  <td class="text-center">
                    {{item.delegated_payment | currency:'S/. '}}
                  </td>
                  <td class="f-s-10">
                    {{item.observation}}
                  </td>
                  <td class="text-center">
                    {{item.price_corporate * item.quantity | currency:'S/. '}}
                  </td>
                </tr>
              </ng-container>
            </tbody>
            <tfoot>
              <tr class="bold">
                <td colspan="8" class="text-right">RESUMEN TOTAL TRASPASOS</td>
                <td class="text-center bold f-s-12">
                  {{total_transfers | currency:'S/. '}}
                </td>
              </tr>
              <tr class="bold">
                <td colspan="8" class="text-right"><i class="fas fa-info-circle m-l-5"></i> Cobros delegados
                </td>
                <td class="text-center bold f-s-12">- {{total_delegated_payment | currency:'S/. '}}</td>
              </tr>
              <tr class="bold text-danger f-s-12">
                <td colspan="8" class="text-right">BALANCE TRASPASOS</td>
                <td class="text-center bold">{{ (total_transfers - total_delegated_payment) | currency:'S/. '}}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <div class="col-lg-12 m-t-25">
        <p class="form__group__title text-success bold"><i class="fas fa-arrow-left text-success m-r-5"></i> RECIBIDOS
        </p>
        <div class="table-responsive">
          <table class="table mb-0 table-sm">
            <thead class="thead-default">
              <tr>
                <th>Responsable y Código</th>
                <th>Hotel / Ubicacion</th>
                <th>Tour</th>
                <th class="text-center">N° PAX</th>
                <th class="text-center">Fecha</th>
                <th class="text-center">P. Corporativo</th>
                <th class="text-center"> C. Asignada</th>
                <th class="text-center">Obs.</th>
                <th class="text-center">Total</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="receiveds.length == 0">
                <tr>
                  <td colspan="7">
                    No se encontraron registros.
                  </td>
                </tr>
              </ng-container>
              <ng-container *ngIf="receiveds.length > 0">
                <tr *ngFor="let item of receiveds; let index_ = index">
                  <td>
                    {{item.client_fullname}} <span class="m-l-2 f-s-10">({{item.client_cellphone}})</span>
                    <p class="m-b-2 f-s-11 bold" style="color: #a56b6b;">{{item.booking_code}}</p>
                  </td>
                  <td>{{item.reference_location}}</td>
                  <td>{{item.tour}}</td>
                  <td class="text-center">
                    {{item.quantity}}
                  </td>
                  <td class="text-center">
                    {{item.date_assigned}}
                  </td>
                  <td class="text-center">
                    {{item.price_corporate | currency:'S/. '}}
                  </td>
                  <td class="text-center">
                    {{item.assigned_payment | currency:'S/. '}}
                  </td>
                  <td class="f-s-10">
                    {{item.observation}}
                  </td>
                  <td class="text-center">
                    {{item.price_corporate * item.quantity | currency:'S/. '}}
                  </td>
                </tr>
              </ng-container>
            </tbody>
            <tfoot>
              <tr class="bold">
                <td colspan="8" class="text-right">RESUMEN TOTAL RECIBIDOS</td>
                <td class="text-center bold f-s-12">{{total_receiveds | currency:'S/. '}}
                </td>
              </tr>
              <tr class="bold">
                <td colspan="8" class="text-right"><i class="fas fa-info-circle m-l-5"></i>
                  Cobros asignados</td>
                <td class="text-center bold f-s-12">- {{total_assigned_payment | currency:'S/. '}}</td>
              </tr>
              <tr class="bold text-success f-s-12">
                <td colspan="8" class="text-right">BALANCE RECIBIDOS</td>
                <td class="text-center bold">{{ (total_receiveds - total_assigned_payment) | currency:'S/. '}}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
